// Frontend mirror of server/utils/inspectionCategories.js
// Keep this in sync with the server file when you change the list.
//
// IDs must match exactly - they are sent to the backend in the request body
// and resolved against the active carrier's published rulebook version.

export const INSPECTION_CATEGORIES = [
  {
    id: 'hh',
    label_fa: 'منهول (HH)',
    description_fa: 'بازرسی منهول، حوضچهٔ کابل و ورودی‌های آن',
  },
  {
    id: 'fat',
    label_fa: 'FAT (تجهیز توزیع نوری)',
    description_fa: 'بازرسی نصب و فرم‌گیری FAT',
  },
  {
    id: 'odc',
    label_fa: 'ODC (کابینت اپتیکی)',
    description_fa: 'بازرسی نصب و فرم‌گیری کابینت ODC',
  },
  {
    id: 'closure',
    label_fa: 'کلوزر (Splice Closure)',
    description_fa: 'بازرسی نصب کلوزر و اسپلایس',
  },
  {
    id: 't-connector',
    label_fa: 'T-Connector',
    description_fa: 'بازرسی نصب و فرم‌گیری T-Connector',
  },
  {
    id: 'ball-test',
    label_fa: 'تست توپ و شوت فیبر',
    description_fa: 'بازرسی تست توپ و عملیات شوت کردن فیبر',
  },
  {
    id: 'excavation',
    label_fa: 'حفاری FTTH',
    description_fa: 'بازرسی حفاری و کانال‌کشی',
  },
  {
    id: 'site-entry',
    label_fa: 'ورود به سایت',
    description_fa: 'بازرسی ورود به سایت و راه‌اندازی اولیه',
  },
];
